import { render, staticRenderFns } from "./view-documentos.vue?vue&type=template&id=9ff2f026"
import script from "./view-documentos.vue?vue&type=script&lang=js"
export * from "./view-documentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports